import { createAction, props } from "@ngrx/store";
import IUserSkill from "@skills-app/models/userSkills";
import { ISkillNode } from "@skills-app/models/skillNode";
import { ITeam } from "@skills-app/models/team";

const prefix = "[Build Team Page]";

export const loadPage = createAction(`${prefix} Load Page`);
export const unloadPage = createAction(`${prefix} Unload Page`);

export const loadExistingTeam = createAction(
  `${prefix} Load Existing Team`,
  props<{ teamSlug: string }>(),
);

export const addToTeam = createAction(
  `${prefix} Add To Team`,
  props<{ userSkills: IUserSkill[] }>(),
);

export const removeFromTeam = createAction(
  `${prefix} Remove From Team`,
  props<{ userSkill: IUserSkill }>(),
);

export const addSkillToTeamMatrixFilter = createAction(
  `${prefix} Add Skill To Team Matrix Filter`,
  props<{ skill: ISkillNode }>(),
);

export const addAllSkillsToTeamMatrixFilter = createAction(
  `${prefix} Add All Skills To Team Matrix Filter`,
  props<{ skills: ISkillNode[] }>(),
);

export const removeSkillFromTeamMatrixFilter = createAction(
  `${prefix} Remove Skill From Team Matrix Filter`,
  props<{ skill: ISkillNode }>(),
);

export const removeAllSkillsFromTeamMatrixFilter = createAction(
  `${prefix} Remove All Skills From Team Matrix Filter`,
);

export const upsertTeam = createAction(
  `${prefix} Upsert Team`,
  props<{ team: ITeam }>(),
);

export const deleteTeam = createAction(
  `${prefix} Delete Team`,
  props<{ teamId: number }>(),
);

export const generateCSVForTeam = createAction(
  `${prefix} Generate Team CSV`,
  props<{ team: ITeam; includeSkills: boolean }>(),
);

export const loadAllTeams = createAction(`${prefix} Load all teams for user`);
